import { render, staticRenderFns } from "./project-subevent.vue?vue&type=template&id=3647a20d&"
import script from "./project-subevent.vue?vue&type=script&lang=js&"
export * from "./project-subevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports